<template>
    <div class="flex items-center justify-center w-full py-20 xl:h-screen">
        <div class="max-w-md sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-xl 2xl:max-w-2xl 3xl:max-w-3xl 4xl:max-w-4xl mx-auto lg:px-4 3xl:px-10">
            <swiper
                :modules="[Navigation, Pagination, Autoplay]"
                :pagination="{
                    clickable: true,
                    bulletActiveClass: 'swiper-pagination-bullet-active custom-bullet-active'
                }"
                :navigation="{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }"
                :loop="true"
                :autoplay="{
                    delay: 5000,
                    disableOnInteraction: false
                }"
                class="custom-swiper h-full"
            >
                <swiper-slide v-for="(slide, index) in slides" :key="index">
                    <div class="flex flex-col h-full">
                        <div class="mb-10 flex-shrink-0">
                            <div class="w-full h-[30rem] xl:h-[36rem] relative rounded-lg overflow-hidden">
                                <img
                                    class="absolute inset-0 w-full h-full object-cover object-left-top shadow-xl"
                                    :src="slide.image"
                                    :alt="slide.title"
                                />
                            </div>
                        </div>
                        <div class="text-center px-4 flex-grow flex flex-col justify-center">
                            <h3 class="text-xl md:text-2xl font-bold text-indigo-600 mb-2">{{ slide.title }}</h3>
                            <p class="text-sm md:text-base font-light leading-relaxed text-slate-500">{{ slide.description }}</p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { useLanguage } from "@/Composables/useLanguage.js";
import { useI18n } from 'vue-i18n';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const { locale } = useLanguage();
const { t } = useI18n();

// Reactive `slides` using computed instead of ref
const slides = computed(() => [
    {
        image: `/assets/images/registration/${locale.value}/registration_1.png`,
        title: t('register.slides.slide_1.title'),
        description: t('register.slides.slide_1.description'),
    },
    {
        image: `/assets/images/registration/${locale.value}/registration_2.png`,
        title: t('register.slides.slide_2.title'),
        description: t('register.slides.slide_2.description'),
    },
    {
        image: `/assets/images/registration/${locale.value}/registration_3.png`,
        title: t('register.slides.slide_3.title'),
        description: t('register.slides.slide_3.description'),
    }
]);

// Optional: You can watch for locale changes explicitly to trigger reactivity
watch(() => locale.value, (newLocale) => {
    console.log('Language changed to:', newLocale);
});
</script>

<style scoped>
.swiper-button-next::after,
.swiper-button-prev::after {
    display: none;
}

.custom-swiper {
    padding-bottom: 55px;
}

.custom-swiper .swiper-pagination {
    bottom: 0 !important;
}

.custom-swiper :deep(.swiper-pagination-bullet.swiper-pagination-bullet-active),
.custom-swiper :deep(.swiper-pagination-bullet.custom-bullet-active) {
    opacity: 1 !important;
    background-color: #4c43dc !important;
}

.custom-swiper .swiper-slide {
    display: flex;
    flex-direction: column;
    height: auto;
}
</style>
